// ~/store/auth.ts
import { defineStore } from 'pinia'
import { getLastLotteries } from '~/utils/last-lotteries'

const initialState = {
	loading: false,
	lotteries: [] as Array<any>,
}

/**
 * Pinia store for the global lottery-notification banner.
 * Fetches the latest draw results via the Nitro `/api/notification` route and exposes
 * a `getLasLotteries` getter that merges the API response with the static lottery catalogue.
 */
export const useNotificationStore = defineStore('notification', {
	state: () => ({ ...initialState }),
	getters: {
		getLasLotteries: (state) => {
			if (state.lotteries.length === 0) return []
			return getLastLotteries(state.lotteries)
		},
	},
	actions: {
		/** Sets any top-level state property by key. */
		SET_STATE_NOTIFICATION({ type, value }: { type: string; value: any }) {
			;(this as any)[type] = value
		},
		/** Fetches the latest lottery draw notifications and stores them. Returns a safe POJO on failure. */
		async fetchLastLotteries() {
			this.loading = true

			try {
				const response = await $fetch<Record<string, any>>('/api/notification')

				const lotteries = Array.isArray(response?.result?.lotteries) ? response.result.lotteries.filter(Boolean) : []

				if (response?.success === true) {
					this.lotteries = lotteries
				}

				return response
			} catch (error) {
				console.warn('[store.notification] fetchLastLotteries failed', error)
				return {
					success: false,
					result: { lotteries: [] },
				}
			} finally {
				this.loading = false
			}
		},
	},
})
